import { render, staticRenderFns } from "./PhotoServiceEventsTable.vue?vue&type=template&id=063ad4cd&"
import script from "./PhotoServiceEventsTable.vue?vue&type=script&lang=js&"
export * from "./PhotoServiceEventsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports